export const DEFAULT_PAGINATION_SIZE = 50
export const FILE_SIZE = 1000000

export const Z_INDEX = {
  NAVBAR: 100,
  MAINCONTENT: 50,
}
